<div class="iv-review" [formGroup]="form">
  <h3 class="iv-review__title">Verification Result</h3>

  <p class="iv-review__hint">
    Enter the income determined through the verification process. It is written to the household record when this
    task is accepted, and is used for tier and award calculations from that point on.
  </p>

  <div class="iv-review__grid">
    <div class="iv-review__field">
      <label for="verifiedIncomeInput" class="iv-review__label" [attr.aria-label]="'Verified Income'">
        Verified Income
      </label>
      <mat-form-field class="iv-review__control">
        <span matTextPrefix>$&nbsp;</span>
        <input
          id="verifiedIncomeInput"
          data-pw="verified_income_input"
          data-qa="verified_income_input"
          matInput
          type="number"
          min="0"
          step="0.01"
          placeholder="Verified Income"
          formControlName="verifiedIncome" />
        @if (form.get('verifiedIncome')?.hasError('required') && form.get('verifiedIncome')?.touched) {
          <mat-error>Verified Income is required to accept this task</mat-error>
        }
        @if (form.get('verifiedIncome')?.hasError('min')) {
          <mat-error>Verified Income cannot be negative</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="iv-review__field">
      <label for="verifiedHouseholdSizeInput" class="iv-review__label" [attr.aria-label]="'Verified Household Size'">
        Verified Household Size
      </label>
      <mat-form-field class="iv-review__control">
        <input
          id="verifiedHouseholdSizeInput"
          data-pw="verified_household_size_input"
          data-qa="verified_household_size_input"
          matInput
          type="number"
          min="1"
          step="1"
          placeholder="Verified Household Size"
          formControlName="verifiedHouseholdSize" />
        @if (
          form.get('verifiedHouseholdSize')?.hasError('required') && form.get('verifiedHouseholdSize')?.touched
        ) {
          <mat-error>Verified Household Size is required</mat-error>
        }
        @if (form.get('verifiedHouseholdSize')?.hasError('min')) {
          <mat-error>Verified Household Size must be at least 1</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</div>
